import { useEffect, useState } from 'react';

import { FULLSCREEN_EVENT, type FullscreenEventDetail } from './fullscreen-event';

/**
 * Used by MFE Sidebar components to hide themselves when fullscreen mode is active.
 * Listens for the herond:fullscreen CustomEvent dispatched by the host-ui shell.
 *
 * @returns isFullscreen — true when the app is in fullscreen mode
 */
export const useFullscreenHidden = (): boolean => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handler = (e: Event) => {
      setIsFullscreen((e as CustomEvent<FullscreenEventDetail>).detail.active);
    };

    window.addEventListener(FULLSCREEN_EVENT, handler);
    return () => window.removeEventListener(FULLSCREEN_EVENT, handler);
  }, []);

  return isFullscreen;
};
